import React from 'react';

import {useEnter} from '@pexip/hooks';

import type {ColorScheme} from '../../../types/variants';

import {ToggleSwitchDisplay} from './ToggleSwitchDisplay';

import styles from './ToggleSwitch.module.scss';

export interface ToggleSwitchProps extends Omit<
    React.ComponentProps<'input'>,
    'onChange'
> {
    checked: boolean;
    className?: string;
    isSmall?: boolean;
    name: string;
    label: string;
    labelClassName?: string;
    labelPosition?: 'start' | 'end';
    labelModifier?: 'hidden' | 'spaced';
    labelFontWeight?: 'normal' | 'bold';
    onChange: (isChecked: boolean) => void;
    colorScheme?: ColorScheme;
}

export const ToggleSwitch: React.FC<
    Omit<ToggleSwitchProps, 'type' | 'style'>
> = ({
    checked,
    className,
    label,
    labelClassName,
    labelPosition = 'end',
    labelModifier,
    labelFontWeight,
    onChange,
    isSmall,
    colorScheme,
    ...props
}) => {
    const {onKeyDown} = useEnter<HTMLInputElement>(e => {
        onChange(!e.currentTarget.checked);
    });
    return (
        <ToggleSwitchDisplay
            as="label"
            checked={checked}
            className={className}
            label={label}
            labelClassName={labelClassName}
            labelPosition={labelPosition}
            labelModifier={labelModifier}
            labelFontWeight={labelFontWeight}
            isSmall={isSmall}
            colorScheme={colorScheme}
        >
            <input
                type="checkbox"
                checked={checked}
                className={styles.input}
                onChange={e => onChange(e.currentTarget.checked)}
                onKeyDown={onKeyDown}
                {...props}
            />
        </ToggleSwitchDisplay>
    );
};
